import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import rocketImg      from '../../../assets/rocket-removebg-preview.png';
import ringImg        from '../../../assets/ring.png';
import rocketBanner   from '../../../assets/aerosapce rocket banner.jpg';
import aeRingImg      from '../../../assets/AE RING Ø 2250MM.jpg';
import canisterImg    from '../../../assets/CANISTER Ø 2250MM.jpg';
import tBulkRingImg   from '../../../assets/T BULK RING Ø 2840MM (ALU).jpg';
import aftShieldImg   from '../../../assets/AFT SHEILD ASSY  FIX.jpg';
import csatImg        from '../../../assets/CSAT ASSY FIX 4.2 METER.jpg';

import nadirImg       from '../../../assets/NADIR ASSY FIX 4.4 METER.jpg';
import vsscImg        from '../../../assets/VSSC-GAGANYAAN.jpg';
import pic4Img        from '../../../assets/Picture4.jpg';

// Aerospace sector assembly images
import aeroSectorAssembly1 from '../../../assets/aerospace c setor asseply.jpeg';
import aeroSectorAssembly2 from '../../../assets/aerospace c setor asseply fixture.jpeg';
import cSectFix1 from '../../../assets/c sect assebly fix (1).jpeg';
import cSectFix2 from '../../../assets/c sect assebly fix (2).jpeg';


// Building Components That Leave Earth folder images
import bcImg1 from '../../../assets/Building ComponentsThatLeave Earth/CNC_Vertical_Turning-removebg-preview.png';
import bcImg2 from '../../../assets/Building ComponentsThatLeave Earth/MasterCAM_26-removebg-preview.png';
import bcImg3 from '../../../assets/Building ComponentsThatLeave Earth/Material Expertise.jpg';
import bcImg4 from '../../../assets/Building ComponentsThatLeave Earth/dimension.jpg';

import './Aerospace.css';

// Aerospace + Defence product gallery — windmill-style cards (NO cement images)
const aerospaceGallery = [
  {
    id: 1,
    name: 'Fore End Ring',
    spec: 'Ø 2840 mm (ALU)',
    client: 'ISRO',
    img: tBulkRingImg,
    tag: 'Aerospace',
    desc: 'CNC-machined aluminium ring forming the fore-end structural boundary of PSLV launch vehicles.',
  },
  {
    id: 3,
    name: 'AE Ring',
    spec: 'Ø 2250 mm',
    client: 'ISRO',
    img: aeRingImg,
    tag: 'Aerospace',
    desc: 'Aft equipment bay ring machined to micron tolerances for satellite integration.',
  },
  {
    id: 5,
    name: 'Canister Ø 2250',
    spec: 'Ø 2250 mm',
    client: 'ISRO / VSSC',
    img: canisterImg,
    tag: 'Aerospace',
    desc: 'Cylindrical canister for avionics and telemetry systems aboard ISRO launch vehicles.',
  },
  {
    id: 6,
    name: 'Canister Ø 2500',
    spec: 'Ø 2500 mm HT-2250',
    client: 'ISRO / VSSC',
    img: pic4Img,
    tag: 'Aerospace',
    desc: 'Larger canister with extended height for GSLV payload accommodation.',
  },
  {
    id: 7,
    name: 'CEOS Adaptor',
    spec: 'Gaganyaan Programme',
    client: 'VSSC',
    img: vsscImg,
    tag: 'Gaganyaan',
    desc: "Crew module adaptor for India's crewed spaceflight mission — manufactured & painted by MILLTECH CNC.",
  },
  {
    id: 8,
    name: 'NADIR Assembly',
    spec: '4.4 Metre Span',
    client: 'ISRO',
    img: nadirImg,
    tag: 'Aerospace',
    desc: 'Large nadir-pointing instrument mounting fixture for satellite integration.',
  },
  {
    id: 9,
    name: 'CSAT Assembly',
    spec: '4.2 Metre Span',
    client: 'ISRO',
    img: csatImg,
    tag: 'Aerospace',
    desc: 'Communication satellite assembly fixture spanning 4.2m for final integration.',
  },
  {
    id: 2,
    name: 'AFT Shield Assembly',
    spec: 'Fixed Configuration',
    client: 'ISRO',
    img: aftShieldImg,
    tag: 'Aerospace',
    desc: 'Aft-end protective shield assembly with complex interlocking structural geometry.',
  },
  {
    id: 'cs1',
    name: 'C-Sector Assembly',
    spec: 'Structural',
    client: 'ISRO',
    img: aeroSectorAssembly1,
    tag: 'Aerospace',
    desc: 'Precision C-sector assembly for ISRO launch vehicle stage integration.',
  },
  {
    id: 'cs2',
    name: 'C-Sector Fixture',
    spec: 'Assembly Fixture',
    client: 'ISRO',
    img: aeroSectorAssembly2,
    tag: 'Aerospace',
    desc: 'Dedicated fixture for C-sector assembly operations.',
  },
  {
    id: 'cf1',
    name: 'C-Section Fix',
    spec: 'Assembly Fixture',
    client: 'ISRO',
    img: cSectFix1,
    tag: 'Aerospace',
    desc: 'Precision assembly fixture for large-diameter C-section structural work.',
  },
  {
    id: 'cf2',
    name: 'C-Section Fix II',
    spec: 'Assembly Fixture',
    client: 'ISRO',
    img: cSectFix2,
    tag: 'Aerospace',
    desc: 'Secondary C-section fixture for multi-stage assembly operations.',
  },
];

// Defence products — K-4, Canister Ø2500, Bottom Cylinder Assembly, Canister Ø2250


const stats = [
  { value: '25+',    label: 'Years in Aerospace' },
  { value: '0.02mm', label: 'Tolerance Accuracy' },
  { value: '100T',   label: 'Max Load Capacity' },
  { value: '8.2m',   label: 'Max Swing Diameter' },
];

// Building Components capability cards with images
const BC_CARDS = [
  { img: bcImg1, title: 'CNC Vertical Turning',   desc: 'BERTHIEZ 8.2m VTL with 100-ton capacity and 0.02mm accuracy' },
  { img: bcImg2, title: 'MasterCAM 26',           desc: 'In-house 4/5-axis CNC programming for complex toolpaths' },
  { img: bcImg3, title: 'Material Expertise',     desc: 'Aluminium alloys, SS304/316, and high-strength mild steel' },
  { img: bcImg4, title: 'Dimensional Inspection',  desc: 'TESA Uni-master, Pi Tapes, tubular micrometers to 5000mm' },
];

// ── ROCKET RING ASSEMBLY SCENE ──
/*
  PHASES:
  idle       → rocket stable, ring floats gently
  ring-fade  → ring shrinks+fades invisible (800ms)
  cylinder   → cylinder black colour arrow visible, brief pause (1000ms)
  smoke      → smoke starts at rocket nozzle bottom (600ms)
  launching  → rocket flies upward, smoke continues (1500ms)
  launched   → rocket gone, smoke stopped — click to reset
  resetting  → rocket descends back, ring reappears
*/
function RocketAssemblyScene() {
  const [phase, setPhase]         = useState('idle');
  const [ringOpacity, setRingOpacity] = useState(1);
  const [ringScale, setRingScale] = useState(1);
  const [rocketY, setRocketY]     = useState(0);
  const timerRef = useRef([]);
  const rafRef   = useRef(null);
  const phaseRef = useRef('idle');

  const clearAll = () => {
    timerRef.current.forEach(clearTimeout);
    timerRef.current = [];
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
  };

  const easeIn  = t => t * t * (3 - 2 * t);   /* smooth-step: very slow start, gradual acceleration */
  const easeOut = t => 1 - Math.pow(1 - t, 3);

  const handleClick = () => {
    if (phaseRef.current === 'idle') {
      // Phase 1: fade ring out
      phaseRef.current = 'ring-fade';
      setPhase('ring-fade');
      let start = null;
      const dur = 700;
      const fadeRing = (ts) => {
        if (!start) start = ts;
        const t = Math.min((ts - start) / dur, 1);
        setRingOpacity(1 - t);
        setRingScale(1 - t * 0.5);
        if (t < 1) {
          rafRef.current = requestAnimationFrame(fadeRing);
        } else {
          setRingOpacity(0);
          setRingScale(0);
          // Phase 2: show cylinder arrow
          phaseRef.current = 'cylinder';
          setPhase('cylinder');
          // Phase 3: after 900ms start smoke
          timerRef.current.push(setTimeout(() => {
            phaseRef.current = 'smoke';
            setPhase('smoke');
            // Phase 4: after 600ms start launch
            timerRef.current.push(setTimeout(() => {
              phaseRef.current = 'launching';
              setPhase('launching');
              let lStart = null;
              const lDur = 4500;   /* slower, majestic launch */
              const launch = (lts) => {
                if (!lStart) lStart = lts;
                const lt = Math.min((lts - lStart) / lDur, 1);
                // ease in — slow start, fast exit
                setRocketY(-easeIn(lt) * 340);
                if (lt < 1) {
                  rafRef.current = requestAnimationFrame(launch);
                } else {
                  phaseRef.current = 'launched';
                  setPhase('launched');
                  setRocketY(-340);
                }
              };
              rafRef.current = requestAnimationFrame(launch);
            }, 600));
          }, 900));
        }
      };
      rafRef.current = requestAnimationFrame(fadeRing);

    } else if (phaseRef.current === 'launched' || phaseRef.current === 'launching' || phaseRef.current === 'smoke' || phaseRef.current === 'cylinder') {
      // Reset all
      clearAll();
      phaseRef.current = 'resetting';
      setPhase('resetting');
      // Animate rocket back down
      const startY = rocketY;
      let rStart = null;
      const rDur = 900;
      const resetRocket = (ts) => {
        if (!rStart) rStart = ts;
        const t = Math.min((ts - rStart) / rDur, 1);
        setRocketY(startY * (1 - easeOut(t)));
        if (t < 1) {
          rafRef.current = requestAnimationFrame(resetRocket);
        } else {
          setRocketY(0);
          // fade ring back in
          let fStart = null;
          const fDur = 500;
          const fadeIn = (fts) => {
            if (!fStart) fStart = fts;
            const ft = Math.min((fts - fStart) / fDur, 1);
            setRingOpacity(ft);
            setRingScale(ft);
            if (ft < 1) {
              rafRef.current = requestAnimationFrame(fadeIn);
            } else {
              setRingOpacity(1);
              setRingScale(1);
              phaseRef.current = 'idle';
              setPhase('idle');
            }
          };
          rafRef.current = requestAnimationFrame(fadeIn);
        }
      };
      rafRef.current = requestAnimationFrame(resetRocket);
    }
  };

  useEffect(() => () => { clearAll(); }, []);

  const isIdle      = phase === 'idle';
  const showSmoke   = phase === 'smoke' || phase === 'launching';
  const showCylArrow = phase === 'cylinder' || phase === 'smoke' || phase === 'launching';
  const isLaunched  = phase === 'launched';

  const hintText = {
    idle:      'Click the ring — watch it assemble into the rocket cylinder',
    'ring-fade': 'Ring integrating into cylinder...',
    cylinder:  'Ring locked inside black cylinder — preparing for launch',
    smoke:     'Ignition sequence started — smoke from nozzle...',
    launching: 'Rocket launching! 🚀 Click anywhere to reset',
    launched:  '✓ Launched! Click to reset',
    resetting: 'Resetting...',
  }[phase] || '';

  return (
    <div className="ras" onClick={!isIdle ? handleClick : undefined}>
      {/* Starfield */}
      <div className="ras__bg">
        {[...Array(60)].map((_, i) => (
          <div key={i} className="ras__star" style={{
            left:             `${(i * 137.5) % 100}%`,
            top:              `${(i * 89.3) % 100}%`,
            width:            `${0.8 + (i % 4) * 0.5}px`,
            height:           `${0.8 + (i % 4) * 0.5}px`,
            animationDelay:   `${(i * 0.31) % 3}s`,
            animationDuration:`${2 + (i % 5) * 0.6}s`,
          }} />
        ))}
      </div>
      <div className="ras__earth" />

      <div className="ras__inner">
        {/* ROCKET — stable idle, launches up on command */}
        <div
          className={`ras__rocket ${showSmoke || isLaunched ? 'ras__rocket--glow' : ''}`}
          style={{
            transform: `translateY(${rocketY}px)`,
            transition: isIdle ? 'none' : undefined,
          }}
        >
          <img src={rocketImg} alt="Rocket" className="ras__rocket-img" />

          {/* Smoke — ONLY from rocket nozzle bottom, drifts DOWN, starts after cylinder phase */}
          <div className={`ras__smoke ${showSmoke ? 'ras__smoke--active' : ''}`}>
            {[...Array(6)].map((_, i) => (
              <div key={i} className="ras__smoke-puff" style={{ '--si': i }} />
            ))}
          </div>

          {/* Cylinder slot — visible when ring absorbed */}
          <div className={`ras__cylinder-slot
            ${showCylArrow ? 'ras__cylinder-slot--fitted' : ''}
            ${isIdle ? '' : ''}`}>
          </div>

          {/* Cylinder arrow label — appears after ring goes invisible */}
          {showCylArrow && (
            <div className="ras__assembled-label">
              <div className="ras__assembled-bullet">
                <span className="ras__bullet-dot" />
                <div className="ras__bullet-text">
                  <span className="ras__assembled-name">AE Ring Ø 2250mm</span>
                  <span className="ras__assembled-spec">Inside cylinder · ISRO · ±0.02mm</span>
                </div>
              </div>
              <div className="ras__assembled-arrow" style={{ color: '#F59E0B', fontSize: '1.4rem' }}>↙</div>
            </div>
          )}

          {showCylArrow && <div className="ras__fit-glow" />}
        </div>

        {/* RING — floats gently in idle, fades out on click */}
        <div
          className={`ras__ring ${isIdle ? 'ras__ring--float' : ''}`}
          style={{
            opacity: ringOpacity,
            transform: `scale(${ringScale})`,
            pointerEvents: isIdle ? 'auto' : 'none',
            cursor: isIdle ? 'pointer' : 'default',
            transition: isIdle ? 'none' : undefined,
          }}
          onClick={isIdle ? handleClick : undefined}
        >
          <img src={ringImg} alt="AE Ring Ø2250mm" className="ras__ring-img" />
          <div className="ras__ring-shine" />
          {isIdle && <div className="ras__ring-pulse" />}
        </div>
      </div>

      {/* Hint bar */}
      <div className={`ras__hint ${isLaunched ? 'ras__hint--done' : ''}`}>
        <span className="ras__hint-dot" />
        {hintText}
      </div>

      {/* Corner labels */}
      <div className="ras__labels">
        <div className="ras__label">
          <span>ISRO PSLV Rocket</span>
          <span className="ras__label-spec">
            {isIdle ? 'Stable · Awaiting ring' : isLaunched ? 'Launched ✓' : 'In sequence...'}
          </span>
        </div>
        <div className="ras__label ras__label--right">
          <span>AE Ring Ø 2250mm</span>
          <span className="ras__label-spec">
            {isIdle ? 'Click ring to launch sequence' : showCylArrow ? 'Inside cylinder' : 'Integrating...'}
          </span>
        </div>
      </div>
    </div>
  );
}

// ── WINDMILL-STYLE PRODUCT CARD for Aerospace gallery ──
function AeroGalleryCard({ product, index }) {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVis(true); obs.disconnect(); } },
      { threshold: 0.08 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`aero-gal-card ${vis ? 'aero-gal-card--visible' : ''}`}
      style={{ transitionDelay: `${(index % 4) * 0.08}s` }}
    >
      <div className="aero-gal-card__img-wrap">
        <img
          src={product.img}
          alt={product.name}
          className="aero-gal-card__img"
          onError={e => { e.target.style.display = 'none'; }}
        />
        <span className="aero-gal-card__tag">{product.tag}</span>
        <span className="aero-gal-card__client">{product.client}</span>
      </div>
      <div className="aero-gal-card__body">
        <h3 className="aero-gal-card__name">{product.name}</h3>
        <span className="aero-gal-card__spec">{product.spec}</span>
        <p className="aero-gal-card__desc">{product.desc}</p>
        {typeof product.id === 'number' && product.id <= 11 && (
          <Link to={`/products/${product.id}`} className="aero-gal-card__btn">
            View Details →
          </Link>
        )}
      </div>
    </div>
  );
}

export default function Aerospace() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const els = document.querySelectorAll('.aero-reveal');
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.05 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="aerospace-page">

      {/* ── HERO — updated heading ── */}
      <section className="aero-hero">
        <div className="aero-hero__bg">
          <img src={rocketBanner} alt="Aerospace hero" className="aero-hero__bg-img" />
          <div className="aero-hero__bg-overlay" />
        </div>
        <div className="container aero-hero__content">
          <div className="aero-hero__text aero-reveal">
            {/* Updated tag + title as requested */}
            <span className="aero-hero__tag">Aerospace &amp; Defence Division</span>
            <h1 className="aero-hero__title">
              Precision Machined for the<br/>
              <span className="aero-hero__accent">Final Frontier</span>
            </h1>
            <p className="aero-hero__sub">
              MILLTECH CNC manufactures mission-critical structural components for
              ISRO, BrahMos, and India's Gaganyaan crewed spaceflight mission.
            </p>
            <div className="aero-hero__clients">
              {['ISRO', 'BrahMos', 'VSSC', 'Gaganyaan', 'IGCAR'].map(c => (
                <span key={c} className="aero-client-chip">{c}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="aero-hero__wave">
          <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#F8FAFF" />
          </svg>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="aero-stats-section">
        <div className="container">
          <div className="aero-stats-grid aero-reveal">
            {stats.map(s => (
              <div key={s.label} className="aero-stat-card">
                <span className="aero-stat-value">{s.value}</span>
                <span className="aero-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── BUILDING COMPONENTS THAT LEAVE EARTH ── */}
      <section className="aero-about section">
        <div className="container">
          <div className="aero-about__grid">
            <div className="aero-reveal">

              <h2 className="section-title">
                Building Components<br/><span style={{ color: 'var(--red)' }}>That Leave Earth</span>
              </h2>
              <div className="line-red" />
              <p className="aero-about__p">
                Since 2002, MILLTECH CNC has been at the forefront of aerospace component manufacturing in India.
                Our Unit 2 facility houses a BERTHIEZ 8.2m CNC VTL — one of the largest in South Asia.
              </p>
              <p className="aero-about__p">
                We work directly with ISRO's VSSC and LPSC supplying rings, canisters, and assembly fixtures for PSLV
                and GSLV. Our Gaganyaan crew module adaptor is a milestone in Indian aerospace manufacturing.
              </p>
              <Link to="/contact" className="btn btn-indigo" style={{ marginTop: '1.5rem' }}>
                Request a Quote →
              </Link>
            </div>
            <div className="aero-caps-grid aero-reveal">
              {BC_CARDS.map((c, i) => (
                <div key={i} className="aero-cap-card">
                  <div className="aero-cap-card__img-wrap">
                    <img src={c.img} alt={c.title} className="aero-cap-card__img" />
                  </div>
                  <div className="aero-cap-card__body">
                    <h3 className="aero-cap-title">{c.title}</h3>
                    <p className="aero-cap-desc">{c.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── INTERACTIVE ASSEMBLY ── */}
      <section className="aero-3d-section section">
        <div className="container">
          <div className="aero-reveal" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            <p className="eyebrow" style={{ justifyContent: 'center' }}>Interactive Demo</p>
            <h2 className="section-title">Ring Component Assembly</h2>
            <p style={{ color: 'white', fontSize: '0.95rem', maxWidth: '500px', margin: '0 auto' }}>
              Watch how MILLTECH CNC rings integrate into ISRO launch vehicles.
              Click the ring to assemble, click the label to reset.
            </p>
          </div>
          <RocketAssemblyScene />
        </div>
      </section>

      {/* ── AEROSPACE PRODUCT GALLERY — windmill-style cards ── */}
      <section className="aero-products section">
        <div className="container">
          <div className="aero-reveal" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            
            <h2 className="section-title">Aerospace Product Gallery</h2>
            <p style={{ color: 'var(--txt-3)', fontSize: '0.95rem', maxWidth: '600px', margin: '0.75rem auto 0' }}>
              Mission-critical components manufactured for ISRO's PSLV, GSLV, and Gaganyaan programmes.
            </p>
          </div>
          <div className="aero-gal-grid">
            {aerospaceGallery.map((p, i) => (
              <AeroGalleryCard key={`${p.id}-${i}`} product={p} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="aero-cta">
        <div className="aero-cta__bg" />
        <div className="container aero-cta__inner aero-reveal">
          <div>
            <h2 className="aero-cta__title">Ready to Manufacture Your Aerospace Component?</h2>
            <p className="aero-cta__sub">Send us your drawings. Our engineering team responds within 24 hours.</p>
          </div>
          <div className="aero-cta__btns">
            <Link to="/contact" className="btn btn-red">Request a Quote</Link>
            <Link to="/products" className="btn btn-outline" style={{ borderColor: 'rgba(255,255,255,0.4)', color: '#fff' }}>
              View All Products →
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}